import { render, staticRenderFns } from "./NDICReport.vue?vue&type=template&id=19363cfb&"
import script from "./NDICReport.vue?vue&type=script&lang=js&"
export * from "./NDICReport.vue?vue&type=script&lang=js&"
import style0 from "./NDICReport.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports